import { useState } from 'react';
import { ExportLeiste, Feld } from '../muster';
import type { ExportZiel } from '../muster';

/**
 * Die Ausgaben des Heiz- bzw. Kühllastausweises (TL3, TX-STANDARD S1.9).
 *
 * Drei PDF-Umfänge, weil drei verschiedene Leser:
 *
 *   Zusammenfassung  für die Übergabe - Lauf, Status, Grundlagen, Annahmen,
 *                    Ergebnisse, Befunde.
 *   Raumübersicht    für die Auslegung - zusätzlich eine Zeile je Raum.
 *   Raumdetail       für die Prüfung - zusätzlich das Raumblatt mit
 *                    Bauteilnachweis und Rechenweg bzw. der Tagesgang.
 *
 * Dazu Excel: dieselben Zahlen als Listenmappe (Umfang „Raumdetail“, ganzes
 * Gebäude - Datenhash gleich dem PDF „Raumdetail“).
 *
 * Die Geschosswahl gilt nur für das PDF: Ein Bauleiter braucht die Räume
 * seines Geschosses und nicht alle. Der Ausschnitt heißt im PDF „Ebene …“
 * und nicht „Gebäude“ (Befund F-A4).
 *
 * Seit TX2 (F11) liefert der Server bei gleichem Stand die abgelegte Fassung;
 * der PDF-Knopf trägt deshalb keinen Hinweis „neue Fassung je Abruf“.
 */
export function Berichtsknoepfe({ ebenen, laden, excel }: {
  ebenen: string[];
  laden: (umfang: string, ebene?: string) => Promise<void>;
  /** Lädt die Excel-Mappe des gezeigten Laufs. Fehlt er, gibt es keinen Excel-Knopf. */
  excel?: () => Promise<void>;
}) {
  const [ebene, setEbene] = useState('');
  const gewaehlt = ebene === '' ? undefined : ebene;

  const ziele: ExportZiel[] = [
    { art: 'pdf', beschriftung: 'PDF Zusammenfassung', laden: () => laden('zusammenfassung', gewaehlt) },
    { art: 'pdf', beschriftung: 'PDF Raumübersicht', laden: () => laden('raeume', gewaehlt) },
    { art: 'pdf', beschriftung: 'PDF Raumdetail', laden: () => laden('detail', gewaehlt) },
  ];

  if (excel) {
    ziele.push({
      art: 'excel',
      laden: excel,
      hinweis: 'Ganzes Gebäude, alle Räume und Bauteile.',
    });
  }

  return (
    <div className="m-formabschnitt" data-test="berichtsknoepfe">
      <ExportLeiste ziele={ziele} />

      {ebenen.length > 0 && (
        <div className="m-feldgitter m-feldgitter-3">
          <Feld art="auswahl" beschriftung="Geschoss im PDF" wert={ebene}
            hinweis="Nur für das PDF: Der Ausschnitt heißt dort „Ebene …“, nicht „Gebäude“."
            optionen={[
              { wert: '', beschriftung: 'alle' },
              ...ebenen.map((e) => ({ wert: e, beschriftung: e })),
            ]}
            beiAenderung={(w) => setEbene(w as string)} />
        </div>
      )}
    </div>
  );
}
